<kendo-drawer-container class="drawer-container">
  <kendo-drawer
    mode="push"
    [expanded]="isExpandedValue"
    [width]="expandedWidth"
    [mini]="true"
    [miniWidth]="collapsedWidth"
    position="start"
  >
    <ng-template kendoDrawerTemplate>
      <div class="sidebar-drawer-header">
        <div class="sidebar-header-content" [class.sidebar-expanded]="isExpandedValue">
          @if (logoSrc) {
            <div class="sidebar-logo">
              <img [src]="logoSrc" [alt]="logoAlt || 'Logo'" class="connect-icon" />
            </div>
          }
          @if (isExpandedValue && appName) {
            <div class="sidebar-header-text">
              <span class="sidebar-app-name">{{ appName }}</span>
            </div>
          }
          <div class="sidebar-toggle">
            <button
              kendoButton
              [fillMode]="'flat'"
              (click)="onToggleSidebar()"
              [attr.aria-label]="isExpandedValue ? 'Collapse sidebar' : 'Expand sidebar'"
              [iconClass]="isExpandedValue ? 'fa-light fa-arrow-left-from-bracket' : 'fa-light fa-arrow-right-to-bracket'"
              [title]="isExpandedValue ? 'Collapse menu' : 'Expand menu'"
              class="sidebar-toggle-button"
            >
            </button>
          </div>
        </div>
      </div>
      <nav class="sidebar-nav">
        <ul class="sidebar-menu">
          @for (item of displayMenuItems$ | async; track item.id) {
            <li class="sidebar-menu-item">
              @if (item.type === 'collapse') {
                <div class="sidebar-menu-item-wrapper">
                  <!-- Expanded state: inline toggle + submenu -->
                  @if (isExpandedValue) {
                    <button
                      kendoButton
                      [size]="'medium'"
                      [fillMode]="'flat'"
                      [themeColor]="'base'"
                      (click)="onItemClick(item)"
                      [attr.aria-label]="item.label"
                      [attr.aria-expanded]="isCollapseOpen(item.id)"
                      [iconClass]="item.icon + ' fa-fw fa-lg'"
                      [arrowIcon]="{ iconClass: isCollapseOpen(item.id) ? 'ml-auto fa-light fa-angle-up' : 'ml-auto fa-light fa-angle-down' }"
                      class="sidebar-menu-button"
                    >
                      <span>{{ item.label }}</span>
                    </button>
                    @if (isCollapseOpen(item.id) && item.children) {
                      <ul class="sidebar-submenu">
                        @for (child of item.children; track child.id) {
                          <li class="sidebar-submenu-item">
                            <button
                              kendoButton
                              [size]="'medium'"
                              [fillMode]="'flat'"
                              [themeColor]="isChildActive(child) ? 'primary' : 'base'"
                              [selected]="isChildActive(child)"
                              (click)="onChildItemClick(child)"
                              [attr.aria-label]="child.label + ' menu item'"
                              class="sidebar-menu-button"
                            >
                              <span>{{ child.label }}</span>
                            </button>
                          </li>
                        }
                      </ul>
                    }
                  } @else {
                    <button
                      kendoButton
                      [size]="'medium'"
                      [fillMode]="'flat'"
                      [themeColor]="'base'"
                      (click)="openSubitemsPopup(item, $event)"
                      [attr.aria-label]="item.label + ' menu'"
                      [attr.title]="item.label"
                      [attr.aria-expanded]="popupItem?.id === item.id"
                      [iconClass]="item.icon + ' fa-fw fa-lg'"
                      class="sidebar-menu-button icon-only"
                    >
                    </button>
                  }
                </div>
              } @else {
                <button
                  kendoButton
                  [size]="'medium'"
                  [fillMode]="'flat'"
                  [themeColor]="isItemActive(item) ? 'primary' : 'base'"
                  [selected]="isItemActive(item)"
                  (click)="onItemClick(item)"
                  [attr.aria-label]="isExpandedValue ? item.label : item.label + ' menu item'"
                  [attr.title]="!isExpandedValue ? item.label : ''"
                  [class.icon-only]="!isExpandedValue"
                  [iconClass]="item.icon + ' fa-fw fa-lg'"
                  class="sidebar-menu-button"
                >
                  @if (isExpandedValue) {
                    <span>{{ item.label }}</span>
                  }
                </button>
              }
            </li>
          }
        </ul>
      </nav>

      <!-- Subitems popup for collapsed sidebar -->
      @if (popupItem && popupAnchorEl) {
        <kendo-popup
          [anchor]="popupAnchorEl"
          [anchorAlign]="{ horizontal: 'right', vertical: 'top' }"
          [popupAlign]="{ horizontal: 'left', vertical: 'top' }"
          [margin]="{ horizontal: 16, vertical: 0 }"
          [animate]="true"
          class="sidebar-subitems-popup"
        >
          <div class="sidebar-popup-panel">
            <div class="lw-text-md sidebar-popup-label">
              {{ popupItem.label }}
            </div>
            <ul class="sidebar-popup-menu">
              @for (child of popupItem.children; track child.id) {
                <li>
                  <button
                    kendoButton
                    [size]="'medium'"
                    [fillMode]="'flat'"
                    [themeColor]="isChildActive(child) ? 'primary' : 'base'"
                    [selected]="isChildActive(child)"
                    (click)="onChildItemClick(child)"
                    class="lw-text-md sidebar-popup-menu-button"
                  >
                    {{ child.label }}
                  </button>
                </li>
              }
            </ul>
          </div>
        </kendo-popup>
      }
    </ng-template>
  </kendo-drawer>
</kendo-drawer-container>

